import _ from "lodash";
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useImperativeHandle } from "react";

import I18nHOC from "UIComponents/I18nHOC";
import FullScreenLoader from "UIComponents/FullScreenLoader";

import { connect } from "react-redux";
import { compose } from "lib/apolloClient";
import classNames from "classnames";

import {
  Button,
  Checkbox,
  IconButton,
  Modal,
  TextInput,
  Tooltip,
  EmptyState,
  Dropdown,
  DropdownMenu,
  Tag,
} from "@toddle-edu/ds-web";
import {
  AddCircleOutlined,
  DeleteOutlined,
  DotsVerticalOutlined,
} from "@toddle-edu/ds-icons";
import { NoCategorySetPointBasedAssessmentsIllustration } from "@toddle-edu/ds-theme";

import classes from "./GradeScale.scss";

import { colors, DOUBLE_DIGIT_DECIMAL_NUMBERS_REGEX } from "Constants";
import { generateRandomId } from "Utils";
import { getCriteriaSetLabels } from "Utils/GetCriteriaSetLabels";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import DuplicateTemplateModal from "ScoreCategories/routes/SubjectCategory/components/DuplicateTemplateModal";
import BulkDuplicateTemplateModal from "ScoreCategories/routes/SubjectCategory/components/BulkDuplicateTemplateModal";

import { copyPointAssessment } from "ScoreCategories/modules/ScoreCategoriesModule";
import {
  getEntitiesForCopySet,
  getAssociatedEntitiesForBulkImport,
} from "Administrator/routes/DPAcademicSetup/routes/AssessmentCategories/modules/AssessmentCategoriesModule";
import {
  GRADE_SCALE_INITIAL_STATE,
  createGradeScale,
  updateGradeScale,
  deleteGradeScale,
} from "../../modules/GradeScalesModule";
import {
  validateGradeScaleFields,
  getGradeScaleCreateUpdateInput,
  getGradeScaleDropdownOptions,
  getConfirmationModalContentByAction,
  checkIfGradeScaleIsUpdated,
  GRADE_SCALE_SUB_TYPES_INFO,
} from "../../modules/Utils";
import {
  getOrganizationId,
  getCurrentCurriculumProgramType,
} from "modules/CommonSelectors";
import {
  FINAL_SCORE,
  FINAL_GRADE,
  LOCAL_GRADE,
  CATEGORY_GRADE,
  CURRICULUM_TYPE_UBD,
} from "Constants/stringConstants";
import { canManageGradeBoundaries } from "Settings/modules/SettingsUtils";

import ACLStore from "lib/aclStore";

const styles = {
  weightedScoreTextInput: {
    maxWidth: "100%",
    width: "80px",
  },
  overallGradeTextInput: {
    maxWidth: "100%",
    width: "340px",
  },
  overallGradeTextInputPreview: {
    maxWidth: "100%",
    width: "80px",
  },
};

const GradeScale = props => {
  const {
    t,
    termId,
    grades,
    gradeId,
    termLabel,
    rootNodes,
    subjectId,
    subjectName,
    headerLabel,
    usedCourses,
    headerSubtext,
    gradeScaleSet,
    createGradeScale,
    updateGradeScale,
    deleteGradeScale,
    pointSetVariables,
    isEditMode = false,
    isModalMode = false,
    curriculumProgramId,
    copyPointAssessment,
    isPreviewMode = false,
    customGradeScalesCount,
    openGradeScaleEditModal,
    gradesWithNoCategorySet,
    subjectsWithCategorySet,
    possibleGradeScalesCount,
    subjectsWithNoCategorySet,
    isDefaultGradeScale = false,
    sortedAcademicCriteriaValues,
    canOverrideExistingTemplates,
    isCategoryGradeScale = false,
    scoreBasedAssessmentVariables,
    getOrganizationPointSetRefetch,
    isSubjectSettingsContext = false,
    isFinalGradeManuallyAssigned,
    isAdmin = false,
    organizationId,
    curriculumProgramType,
    isGradingPeriodUnlocked = true,
    showUpdatedDesign = false,
  } = props;

  const [isViewMode, setIsViewMode] = useState(!isEditMode);
  const [gradeScaleObj, setGradeScaleObj] = useState(GRADE_SCALE_INITIAL_STATE);
  const [isLoading, setIsLoading] = useState(false);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [modalState, setModalState] = useState("CLOSED");
  const [selectedGrades, setSelectedGrades] = useState([]);

  const gradeScaleSetId = _.get(gradeScaleSet, "id");
  const templateLabel = _.get(gradeScaleSet, "label", "");
  const subType = _.get(gradeScaleSet, "subType", "");
  const isCustomGradeScale = subType === "CUSTOM";

  const errors = validateGradeScaleFields({
    t,
    fieldValues: _.get(gradeScaleObj, "fieldValues", []),
    isFinalGradeManuallyAssigned,
  });

  const [autoFocusKey, setAutoFocusKey] = useState("");

  const { fieldValues = [] } = gradeScaleObj || {};

  const isSaveButtonDisabled = !_.isEmpty(errors);

  useEffect(() => {
    if (isModalMode) {
      props.setIsSaveButtonDisabled(isSaveButtonDisabled);
    }
  }, [isSaveButtonDisabled]);

  useEffect(() => {
    if (!_.isEmpty(gradeScaleSet)) {
      const fieldValues = _.map(sortedAcademicCriteriaValues, value => {
        const { id, label, values = [] } = value || {};
        return {
          id,
          label,
          percentageWeight: _.get(values, "0.minValue", ""),
          scoreValuesId: _.get(values, "0.id", null),
        };
      });

      const allScoreValuesAreEmpty = _.every(
        sortedAcademicCriteriaValues,
        academicCriteriaValue => _.isEmpty(academicCriteriaValue?.values)
      );

      if (allScoreValuesAreEmpty) {
        setGradeScaleObj({
          ...GRADE_SCALE_INITIAL_STATE,
          id: gradeScaleSetId,
        });
      } else {
        setGradeScaleObj(prevState => ({
          ...prevState,
          id: gradeScaleSetId,
          fieldValues,
        }));
      }
    } else {
      setGradeScaleObj(GRADE_SCALE_INITIAL_STATE);
    }

    return () => setAutoFocusKey("");
  }, [isViewMode, isPreviewMode]);

  const updateWeightedScoreFieldValueLocal = ({ params, index }) => {
    let fieldValue = fieldValues?.[index] || {};
    fieldValue = { ...fieldValue, ...params };

    const updatedFieldValues = _.cloneDeep(
      _.get(gradeScaleObj, "fieldValues", [])
    );
    updatedFieldValues[index] = fieldValue;

    setGradeScaleObj(prevState => ({
      ...prevState,
      fieldValues: updatedFieldValues,
    }));
  };

  const leftContainerClass = classNames({
    [classes.cellLeftContainer]: !showUpdatedDesign,
    [classes.cellInnerConViewMode]: !showUpdatedDesign && isViewMode,
    [classes.cellLeftContainerPreviewMode]: isPreviewMode,
    [classes.cellLeftContainerV2]: showUpdatedDesign,
    [classes.cellInnerConViewModeV2]: showUpdatedDesign && isViewMode,
  });

  const rightContainerClass = classNames({
    [classes.cellRightContainer]: !showUpdatedDesign,
    [classes.cellInnerConViewMode]: !showUpdatedDesign && isViewMode,
    [classes.justifyCenter]: isPreviewMode,
    [classes.cellRightContainerV2]: showUpdatedDesign,
    [classes.cellInnerConViewModeV2]: showUpdatedDesign && isViewMode,
  });

  const orHigherTextClasses = classNames({
    [classes.orHigherText]: !showUpdatedDesign,
    [classes.orHigherTextV2]: showUpdatedDesign,
  });

  const cellViewModeTextClasses = classNames({
    [classes.cellViewModeText]: !showUpdatedDesign,
    ["text-body"]: showUpdatedDesign,
  });

  const renderCell = ({ fieldValue, index }) => {
    const minValue = _.get(fieldValue, "values.0.minValue");

    if (isViewMode) {
      if (_.isEmpty(fieldValue?.values)) return;
    } else {
      if (!_.includes(fieldValue?.id, "NEW")) {
        const currentFieldValue = _.find(
          sortedAcademicCriteriaValues,
          value => {
            return _.get(value, "id") === fieldValue?.id;
          }
        );
        if (_.isEmpty(currentFieldValue?.values)) return;
      }
    }

    const updatePercentageWeight = e => {
      const value = _.get(e, "target.value");
      const valueFloat = parseFloat(value);

      // allow only numbers and upto 2 decimals
      if (!DOUBLE_DIGIT_DECIMAL_NUMBERS_REGEX.test(value) && value) return;

      if (valueFloat >= 100) return;

      updateWeightedScoreFieldValueLocal({
        params: { percentageWeight: value },
        index,
      });
    };

    const updateOverallGrade = e => {
      const label = _.get(e, "target.value");
      updateWeightedScoreFieldValueLocal({
        params: { label },
        index,
      });
    };

    const onClickDelete = () => {
      const updatedFieldValues = _.cloneDeep(
        _.get(gradeScaleObj, "fieldValues", [])
      );
      updatedFieldValues.splice(index, 1);

      setGradeScaleObj(prevState => ({
        ...prevState,
        fieldValues: updatedFieldValues,
      }));
    };

    const fieldValueId = _.get(fieldValue, "id");
    const label = _.get(fieldValue, "label", "");
    const percentageWeight = _.get(fieldValue, "percentageWeight", "");

    const isLastGradeScale = index === _.size(fieldValues) - 1;
    const isPercentageZero = parseInt(percentageWeight) === 0;
    const shouldShowDeleteButton =
      !isPreviewMode &&
      _.size(fieldValues) > 1 &&
      (!isPercentageZero || !(isLastGradeScale && isPercentageZero));

    const { errorMsg = "" } = _.get(errors, `${fieldValueId}`) || {};
    const inputHasError =
      !_.isEmpty(errorMsg) && !_.isEmpty(_.toString(percentageWeight));

    const overallGradeTextInputStyle = isPreviewMode
      ? styles.overallGradeTextInputPreview
      : styles.overallGradeTextInput;

    const onBlur = () => {
      if (_.includes(percentageWeight, ".")) {
        updateWeightedScoreFieldValueLocal({
          params: {
            percentageWeight: _.toString(parseFloat(percentageWeight)),
          },
          index,
        });
      }
    };

    return (
      <div className={classes.evenColumns} key={fieldValueId}>
        {!isFinalGradeManuallyAssigned ? (
          <div className={leftContainerClass}>
            {!isViewMode ? (
              <React.Fragment>
                <ConditionalWrapper
                  condition={inputHasError}
                  wrapper={
                    <Tooltip
                      placement={"right"}
                      tooltip={errorMsg}
                      dsVersion={showUpdatedDesign ? "2.0" : "1.0"}
                    />
                  }
                  type="wrapperAsElement"
                >
                  <TextInput
                    value={percentageWeight}
                    onChange={updatePercentageWeight}
                    size={showUpdatedDesign ? "medium" : "large"}
                    placeholder={t(
                      "academicSetup:percentage_input_placeholder"
                    )}
                    disabled={
                      isPreviewMode || (isLastGradeScale && isPercentageZero)
                    }
                    style={styles.weightedScoreTextInput}
                    error={inputHasError}
                    autoFocus={autoFocusKey === fieldValueId}
                    onBlur={onBlur}
                    onFocus={() => setAutoFocusKey(fieldValueId)}
                    dsVersion={showUpdatedDesign ? "2.0" : "1.0"}
                  />
                </ConditionalWrapper>

                <div className={orHigherTextClasses}>
                  {t("academicSetup:percentage_or_higher")}
                </div>
              </React.Fragment>
            ) : (
              <div className={cellViewModeTextClasses}>
                {_.isNil(minValue)
                  ? "-"
                  : t("common:or_higher_with_label", {
                      label: `${minValue} %`,
                    })}
              </div>
            )}
          </div>
        ) : null}

        <div className={rightContainerClass}>
          {!isViewMode ? (
            <React.Fragment>
              <TextInput
                value={label}
                disabled={isPreviewMode}
                onChange={updateOverallGrade}
                style={overallGradeTextInputStyle}
                size={showUpdatedDesign ? "medium" : "large"}
                placeholder={t("academicSetup:grade_input_placeholder")}
                onFocus={() => setAutoFocusKey(fieldValueId)}
                dsVersion={showUpdatedDesign ? "2.0" : "1.0"}
              />
              {shouldShowDeleteButton && (
                <IconButton
                  icon={<DeleteOutlined variant="subtle" />}
                  size={showUpdatedDesign ? "medium" : "large"}
                  _legacy_variant="outlined-subtle"
                  variant="neutral"
                  type={showUpdatedDesign ? "plain" : "outlined"}
                  onClick={onClickDelete}
                  dsVersion={showUpdatedDesign ? "2.0" : "1.0"}
                />
              )}
            </React.Fragment>
          ) : (
            <div className={cellViewModeTextClasses}>{label ? label : "-"}</div>
          )}
        </div>
      </div>
    );
  };

  const onClickAddAnother = () => {
    const index = _.findIndex(fieldValues, fieldValue => {
      return _.get(fieldValue, "id") === autoFocusKey;
    });

    const updatedFieldValues = _.cloneDeep(
      _.get(gradeScaleObj, "fieldValues", [])
    );
    updatedFieldValues.splice(index !== -1 ? index : 0, 0, {
      id: generateRandomId(),
      label: "",
      percentageWeight: "",
      scoreValuesId: generateRandomId(),
    });

    setGradeScaleObj(prevState => ({
      ...prevState,
      fieldValues: updatedFieldValues,
    }));

    setAutoFocusKey("");
  };

  const renderCells = () => {
    const academicCriteriaValues = isViewMode
      ? sortedAcademicCriteriaValues
      : fieldValues;

    return _.map(academicCriteriaValues, (fieldValue, index) => {
      return renderCell({ fieldValue, index });
    });
  };

  const innerContainerHeaderClass = classNames(
    classes.evenColumns,
    classes.innerContainerHeader
  );

  const selectedTabSubtextClass = classNames(classes.subtext, "text-body-2");

  const onClickEditBtn = () => {
    if (isSubjectSettingsContext) {
      openGradeScaleEditModal?.({ gradeId, gradeLabel: headerLabel });
      return;
    }
    setIsViewMode(false);
  };

  const onClickCancelBtn = () => {
    setIsViewMode(true);
  };

  const isCustomizingDefaultGradeScale =
    subType === "DEFAULT" && !_.isEmpty(subjectId);

  const saveGradeScale = async (
    isCreateMode = isCustomizingDefaultGradeScale || _.isEmpty(gradeScaleSet)
  ) => {
    setIsLoading(true);

    const input = getGradeScaleCreateUpdateInput({
      termId,
      gradeId,
      subjectId,
      curriculumProgramId,
      academicCriteriaValues: sortedAcademicCriteriaValues,
      isFinalGradeManuallyAssigned,
      gradeScaleObj,
      isDefaultGradeScale,
      isCategoryGradeScale,
      isCreateMode,
      isCustomizingDefaultGradeScale,
    });

    let response;

    if (isCreateMode) {
      response = await createGradeScale({
        input,
        pointSetVariables,
        isCategoryGradeScale,
        scoreBasedAssessmentVariables,
      });
    } else {
      response = await updateGradeScale({
        input,
        pointSetVariables,
        isCategoryGradeScale,
      });
    }

    setIsLoading(false);

    if (!isModalMode) {
      setIsViewMode(true);
    }

    return response;
  };

  useImperativeHandle(props?.gradeScaleRef, () => ({
    saveGradeScale,
  }));

  const onClickSaveBtn = () => {
    const isGradeScaleUpdated = checkIfGradeScaleIsUpdated({
      gradeScaleSet,
      gradeScaleObj,
    });
    if (isGradeScaleUpdated) {
      if (isDefaultGradeScale && !_.isEmpty(gradeScaleSet)) {
        setModalState("SAVE_CONFIRMATION");
      } else {
        saveGradeScale();
      }
    } else {
      setIsViewMode(true);
    }
  };

  const onClickCheckbox = () => {
    setIsCheckboxChecked(prevState => !prevState);
  };

  const onCloseModal = () => {
    if (modalState === "DUPLICATE_TO_OTHER_GRADES") {
      setSelectedGrades([]);
    }
    setModalState("CLOSED");
  };

  const dropdownOptions = getGradeScaleDropdownOptions({
    t,
    isSubjectSettingsContext,
    isGradingPeriodUnlocked,
  });

  const onClickDropdownMenu = e => {
    e.domEvent.stopPropagation();
    const action = e.key;
    switch (action) {
      case "EDIT":
        onClickEditBtn();
        break;
      case "RESET_TO_DEFAULT":
        setModalState("RESET_CONFIRMATION");
        break;
      case "DUPLICATE_TO_OTHER_GRADES":
      case "BULK_DUPLICATE_TO_OTHER_SUBJECTS":
        setModalState(action);
        break;
      default:
        onClickEditBtn();
    }
  };

  const onClickModalSave = async params => {
    switch (modalState) {
      case "SAVE_CONFIRMATION":
        saveGradeScale();
        break;
      case "RESET_CONFIRMATION": {
        setIsLoading(true);
        await deleteGradeScale({
          gradeScaleSetId,
          pointSetVariables,
          scoreBasedAssessmentVariables,
        });
        if (isSubjectSettingsContext) {
          getOrganizationPointSetRefetch?.();
        }
        setIsLoading(false);
        break;
      }
      case "DUPLICATE_TO_OTHER_GRADES":
      case "BULK_DUPLICATE_TO_OTHER_SUBJECTS":
        {
          let entitiesForCopySet = [];
          if (modalState === "DUPLICATE_TO_OTHER_GRADES") {
            const params = {
              grades,
              termId,
              subjectId,
              rootNodes,
              modalState,
              entityType: "Grade",
              subjectsWithCategorySet,
              gradeIds: selectedGrades,
              subjectsWithNoCategorySet,
            };
            entitiesForCopySet = getEntitiesForCopySet(params);
          } else {
            entitiesForCopySet = getAssociatedEntitiesForBulkImport(params);
          }

          setIsLoading(true);
          await copyPointAssessment({
            id: gradeScaleSetId,
            label: templateLabel,
            entitesForCopySet: entitiesForCopySet,
            curriculumProgramId,
            pointSetVariables,
            type: "LOCAL_GRADE",
            scoreBasedAssessmentVariables,
          });
          setIsLoading(false);
        }
        break;
      default:
        return;
    }
    onCloseModal();
  };

  const gradeScaleSubTypeInfo = GRADE_SCALE_SUB_TYPES_INFO[subType];
  const tagLabel = t(gradeScaleSubTypeInfo?.labelLocale);
  const tagColor = gradeScaleSubTypeInfo?.color;

  const hideAddAnotherButton = isViewMode || isPreviewMode;

  const cellContainerClass = classNames({
    [classes.cellContainer]: !showUpdatedDesign,
    [classes.cellContainerPreviewMode]: isPreviewMode,
    [classes.cellContainerV2]: showUpdatedDesign,
    [classes.cellContainerViewMode]: isViewMode && showUpdatedDesign,
  });

  const weightedScoreTextClass = classNames({
    [classes.weightedScoreText]: !showUpdatedDesign,
    [classes.weightedScoreTextPreviewMode]: isPreviewMode,
    ["text-label"]: showUpdatedDesign,
    [classes.weightedScoreTextV2]: showUpdatedDesign,
    [classes.weightedScoreTextViewMode]: isViewMode && showUpdatedDesign,
  });

  const overallGradeText = classNames({
    [classes.overallGradeText]: !showUpdatedDesign,
    [classes.justifyCenter]: isPreviewMode,
    ["text-label"]: showUpdatedDesign,
    [classes.overallGradeTextV2]: showUpdatedDesign,
    [classes.overallGradeTextViewMode]: isViewMode && showUpdatedDesign,
  });

  const isEditingAllowed =
    !isSubjectSettingsContext || canManageGradeBoundaries();

  const criteriaLabels = getCriteriaSetLabels({
    organizationId,
    curriculumProgramId,
    criteriaTypes: [FINAL_SCORE, FINAL_GRADE, LOCAL_GRADE, CATEGORY_GRADE],
  });

  const getCategoryLabelText = () => {
    if (isCategoryGradeScale) {
      return _.get(criteriaLabels, CATEGORY_GRADE, t("common:grade"));
    } else {
      return curriculumProgramType == CURRICULUM_TYPE_UBD
        ? _.get(criteriaLabels, LOCAL_GRADE, t("common:overall_grade"))
        : _.get(criteriaLabels, FINAL_GRADE, t("common:overall_grade"));
    }
  };

  const addAnotherBtnClasses = classNames({
    [classes.addAnotherBtn]: !showUpdatedDesign,
    [classes.addAnotherBtnV2]: showUpdatedDesign,
  });

  return (
    <React.Fragment>
      {!isModalMode ? (
        <div className={classes.headerCon}>
          <div className={classes.leftCon}>
            <div className="text-label-1">{headerLabel}</div>
            {headerSubtext ? (
              <div className={selectedTabSubtextClass}>{headerSubtext}</div>
            ) : null}
          </div>
          {isViewMode ? (
            <div className={classes.rightCon}>
              {!isDefaultGradeScale ? (
                <Tag size={"x-small"} color={tagColor}>
                  {tagLabel}
                </Tag>
              ) : null}

              {isEditingAllowed ? (
                isCustomGradeScale ? (
                  <Dropdown
                    getPopupContainer={el => {
                      return el;
                    }}
                    overlay={
                      <DropdownMenu
                        onClick={onClickDropdownMenu}
                        options={dropdownOptions}
                      />
                    }
                    placement={"bottomRight"}
                  >
                    <IconButton
                      size={"medium"}
                      onClick={e => {
                        e.stopPropagation();
                      }}
                      icon={
                        <DotsVerticalOutlined
                          variant="subtle"
                          size="xx-small"
                        />
                      }
                      variant="outlined"
                    />
                  </Dropdown>
                ) : (
                  <Button
                    variant={"outlined"}
                    size={"large"}
                    onClick={onClickEditBtn}
                    disabled={!isGradingPeriodUnlocked}
                  >
                    {t("common:edit")}
                  </Button>
                )
              ) : null}
            </div>
          ) : (
            <div className={classes.buttonsCon}>
              <Button
                variant={"outlined-subtle"}
                size={"large"}
                onClick={onClickCancelBtn}
              >
                {t("common:cancel")}
              </Button>
              <Button
                variant={"progressive"}
                size={"large"}
                onClick={onClickSaveBtn}
                disabled={isSaveButtonDisabled}
              >
                {t("common:save")}
              </Button>
            </div>
          )}
        </div>
      ) : null}

      {_.isEmpty(sortedAcademicCriteriaValues) && isViewMode ? (
        <div className={classes.emptyStateCon}>
          <EmptyState
            illustration={NoCategorySetPointBasedAssessmentsIllustration}
            title={t("academicSetup:default_grade_boundary_not_defined_yet")}
            subtitle={
              isGradingPeriodUnlocked
                ? t("academicSetup:click_on_edit_to_define_grade_boundary")
                : ""
            }
          />
        </div>
      ) : (
        <div className={cellContainerClass}>
          <div className={innerContainerHeaderClass}>
            {!isFinalGradeManuallyAssigned ? (
              <div className={weightedScoreTextClass}>
                {_.get(
                  criteriaLabels,
                  FINAL_SCORE,
                  t("common:percentage_score")
                )}
              </div>
            ) : null}
            <div className={overallGradeText}>{getCategoryLabelText()}</div>
          </div>

          {renderCells()}

          {!hideAddAnotherButton ? (
            <Button
              icon={<AddCircleOutlined />}
              variant="progressive"
              className={addAnotherBtnClasses}
              onClick={onClickAddAnother}
              size={showUpdatedDesign ? "medium" : "large"}
              _legacy_size="large"
              _legacy_variant="inline-progressive"
              type="inline"
              dsVersion={showUpdatedDesign ? "2.0" : "1.0"}
            >
              {t("common:add_another")}
            </Button>
          ) : null}
        </div>
      )}

      {isLoading ? (
        <FullScreenLoader overlayContainer={classes.overlayContainer} />
      ) : null}

      {renderModal({
        t,
        grades,
        termId,
        gradeId,
        termLabel,
        subjectId,
        rootNodes,
        modalState,
        usedCourses,
        subjectName,
        onCloseModal,
        templateLabel,
        selectedGrades,
        onClickCheckbox,
        onClickModalSave,
        setSelectedGrades,
        isCheckboxChecked,
        customGradeScalesCount,
        gradesWithNoCategorySet,
        possibleGradeScalesCount,
        canOverrideExistingTemplates,
      })}
    </React.Fragment>
  );
};

const renderModal = params => {
  const {
    t,
    grades,
    termId,
    gradeId,
    termLabel,
    subjectId,
    rootNodes,
    modalState,
    usedCourses,
    subjectName,
    onCloseModal,
    templateLabel,
    selectedGrades,
    onClickCheckbox,
    onClickModalSave,
    setSelectedGrades,
    isCheckboxChecked,
    customGradeScalesCount,
    gradesWithNoCategorySet,
    possibleGradeScalesCount,
    canOverrideExistingTemplates,
  } = params;

  switch (modalState) {
    case "SAVE_CONFIRMATION":
    case "RESET_CONFIRMATION": {
      const gradeLabel = _.get(
        _.find(grades, currentGrade => currentGrade?.id === gradeId),
        "name",
        ""
      );

      const modalContent = getConfirmationModalContentByAction({
        t,
        gradeLabel,
        subjectName,
        action: modalState,
        customGradeScalesCount,
        possibleGradeScalesCount,
      });

      const {
        title,
        bodyContent,
        confirmationText,
        saveButtonText,
      } = modalContent;

      const modalContentClass = classNames(classes.modalContent, "text-body-1");

      return (
        <Modal onClose={onCloseModal} width="472px" height="fit-content">
          <Modal.Header title={title} />
          <Modal.Body>
            <div className={classes.modalBodyContainer}>
              <div className={modalContentClass}>{bodyContent}</div>
              <div
                className={classes.confirmationBoxContainer}
                onClick={onClickCheckbox}
              >
                <Checkbox
                  isChecked={isCheckboxChecked}
                  color={{ background: colors.interactiveOneDefault }}
                />
                <div className={modalContentClass}>{confirmationText}</div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className={classes.modalFooterContainer}>
              <Button
                variant="outlined-subtle"
                size="large"
                onClick={onCloseModal}
              >
                {t("common:cancel")}
              </Button>
              <Button
                variant="primary"
                size="large"
                onClick={onClickModalSave}
                disabled={!isCheckboxChecked}
              >
                {saveButtonText}
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      );
    }
    case "DUPLICATE_TO_OTHER_GRADES": {
      const updatedGrades = canOverrideExistingTemplates
        ? _.filter(grades, grade => _.get(grade, "id") !== gradeId)
        : grades;
      const updatedUsedCourses = canOverrideExistingTemplates
        ? []
        : usedCourses;
      const updatedGradesWithNoCategorySet = canOverrideExistingTemplates
        ? _.map(updatedGrades, "id")
        : gradesWithNoCategorySet;

      return (
        <DuplicateTemplateModal
          t={t}
          grades={updatedGrades}
          modalState={modalState}
          subjectName={subjectName}
          usedCourses={updatedUsedCourses}
          closeModal={onCloseModal}
          parentType={"GRADE_SCALES"}
          selectedGrades={selectedGrades}
          onClickDuplicate={onClickModalSave}
          setSelectedGrades={setSelectedGrades}
          gradesWithNoCategorySet={updatedGradesWithNoCategorySet}
          canOverrideExistingTemplates={canOverrideExistingTemplates}
        />
      );
    }
    case "BULK_DUPLICATE_TO_OTHER_SUBJECTS":
      return (
        <BulkDuplicateTemplateModal
          grades={grades}
          gradeId={gradeId}
          targetTermId={termId}
          rootNodes={rootNodes}
          isCurriculumDP={false}
          closeModal={onCloseModal}
          subjectName={subjectName}
          targetTermLabel={termLabel}
          parentType={"GRADE_SCALES"}
          sourceSubjectId={subjectId}
          templateName={templateLabel}
          onClickImport={onClickModalSave}
          canOverrideExistingTemplates={canOverrideExistingTemplates}
        />
      );
    default:
      return null;
  }
};

const mapStateToProps = (state, ownProps) => {
  const { gradeScaleSet = {} } = ownProps;
  const organizationId = getOrganizationId(state);
  const curriculumProgramType = getCurrentCurriculumProgramType(state);

  const academicCriteriaValues = _.get(gradeScaleSet, "categories", []);

  const sortedAcademicCriteriaValues = _.orderBy(
    academicCriteriaValues,
    "displaySequence",
    ["asc"]
  );

  const canOverrideExistingTemplates = ACLStore.can(
    "FeatureFlag:EnableOverridingTemplates"
  );

  return {
    sortedAcademicCriteriaValues,
    canOverrideExistingTemplates,
    organizationId,
    curriculumProgramType,
  };
};

const mapActionCreators = {
  createGradeScale,
  updateGradeScale,
  deleteGradeScale,
  copyPointAssessment,
};

export default compose(
  connect(mapStateToProps, mapActionCreators),
  I18nHOC({ resource: ["common", "academicSetup"] })
)(GradeScale);
